import React, { useContext, useState } from "react";
import StarRating from "react-star-ratings";
import LangContext from "./langContext";
import {
  StyledStarContainer,
  StyledOuterContainer,
  StyledHalfInnerContainer,
  StyledHalfInnerButtonContainer,
} from "./style";

const RatingForm = (props) => {
  const { tempRating, tempComment, saveRating } = props;
  const languageContext = useContext(LangContext);
  const [rating, setRating] = useState(tempRating || 0);
  const [comment, setComment] = useState(tempComment || "");
  const [saved, setSaved] = useState(false);

  const changeRating = (newRating) => {
    setRating(newRating);
  };

  const save = () => {
    if (rating === 0) {
      setSaved(true);
      return;
    }
    saveRating(rating, comment);
  };

  const showErrorMessage = !rating && saved;
  return (
    <StyledOuterContainer>
      <StyledHalfInnerContainer>
        {showErrorMessage && (
          <div className="error" role="alert">
            {languageContext("pleaseenterratingbeforesaving")}
          </div>
        )}
        <StyledStarContainer>
          <StarRating
            rating={rating}
            starRatedColor="#f9db36"
            changeRating={changeRating}
            numberOfStars={5}
            name="rating"
            starDimension="25px"
            starSpacing="4px"
          />
        </StyledStarContainer>
        <label htmlFor="txtComment">
          {languageContext("comment")}
          <textarea
            id="txtComment"
            defaultValue={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </label>
      </StyledHalfInnerContainer>
      <StyledHalfInnerButtonContainer>
        <button
          type="button"
          role="button"
          className="button-cta"
          onClick={save}
        >
          {languageContext("save")}
        </button>
      </StyledHalfInnerButtonContainer>
    </StyledOuterContainer>
  );
};

export default RatingForm;
